<template>
  <div class="mt-4">
    <!-- <label>
      {{ label }}
    </label> -->
    <!-- treeItems:{{ treeItems }} -->

    <div :class="{ 'full-screen-editor': isFullScreen }">
      <v-row>
        <v-col
          v-if="!noFieldList"
          cols="2"
          style="max-height: 70vh; overflow: auto"
        >
          <!-- <label>Fields</label> -->
          <v-text-field
            class="ma-2"
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <!-- {{ treeItems }} -->

          <!-- filter:{{ filter }} -->
          <!-- openItems: {{ openItems }} -->
          <!-- <v-treeview
            :items="[
              {
                text: 'item1',

                children: [{ text: 'child1' }],
              },
              { text: 'item2' },
            ]"
            item-key="text"
            item-text="text"
            :open-all="openAll"
          ></v-treeview> -->
          <v-treeview
            class="ml-n8"
            v-if="modelReady"
            v-model="tree"
            :items="filteredItems"
            :open-all="openAll"
            :open="openItems"
            open-on-click
            transition
            dense
            item-key="text"
            item-text="text"
            key="treeKey"
          >
            <template slot="label" slot-scope="{ item }">
              <!-- <v-icon :draggable="true" @click="insertAtCursor(item, true)">
              drag_indicator
            </v-icon> -->
              <a @click="insertAtCursor(item)">{{ item.text }}</a>
            </template>
          </v-treeview>
          <label>Specials</label>

          <div v-for="(b, i) in specials" :key="i">
            <v-menu-button
              title="Totals"
              :text="true"
              class="ml-n6"
              v-if="b.key == 'totals'"
              :menuItems="totals"
              :menuItemClick="insertAtCursor"
            ></v-menu-button>
            <v-menu-button
              title="Formula"
              :text="true"
              class="ml-n6"
              v-else-if="b.key && b.key == 'formula'"
              :menuItems="formulaItems"
              :menuItemClick="insertAtCursor"
            ></v-menu-button>
            <v-menu-button
              title="Inputs"
              :text="true"
              class="ml-n6"
              v-else-if="b.key == 'inputs'"
              :menuItems="inputItems"
              :menuItemClick="insertAtCursor"
            ></v-menu-button>
            <v-btn v-else class="ml-n2" text @click="insertAtCursor(b)">{{
              b.text
            }}</v-btn>
          </div>
        </v-col>
        <v-col cols="10">
          <v-alert
            class="ma-4"
            dismissible
            timeout="3000"
            v-if="successMessage"
            type="success"
          >
            {{ successMessage }}
          </v-alert>
          <v-alert
            class="ma-4"
            timeout="3000"
            dismissible
            v-if="errorMessage"
            type="error"
          >
            <span v-html="errorMessage"></span>
          </v-alert>
          <!-- model.send_as_link:{{formModel.send_as_link}} -->
          <v-toolbar v-if="!noFieldList" flat>
            <v-switch
              label="PDF/Image Template"
              v-model="isDraggable"
            ></v-switch>
            <v-switch
              label="Edit Template"
              v-model="draggableEdit"
              v-if="isDraggable"
            ></v-switch>
            <v-spacer></v-spacer>
            <v-tooltip v-if="!isMobile && !noFullScreen" top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="toggleFullScreen"
                  ><v-icon v-if="!isFullScreen">mdi-fullscreen</v-icon
                  ><v-icon round color="error" v-else
                    >mdi-fullscreen-exit</v-icon
                  ></v-btn
                >
              </template>
              <span>Toggle Full Screen</span>
            </v-tooltip>
          </v-toolbar>
          <!-- -->
          <!-- isDraggable {{ isDraggable }} draggableEdit {{ draggableEdit }} -->
          <div v-show="!isDraggable || draggableEdit">
            <v-label v-if="label">{{ label }}</v-label>
            <ckeditor
              v-if="!isSms"
              ref="editor"
              id="editor"
              width="100%"
              :config="editorConfig"
              :placeholders="treeItems"
              v-model="model"
              @namespaceloaded="onNamespaceLoaded"
            ></ckeditor>
            <div
              style="max-height: 100vh; overflow: auto"
              v-else
              id="editor"
              contenteditable
              class="v-content-editable"
              @input="onInput"
            ></div>
          </div>
          <div
            id="draggable_div"
            v-if="isDraggable && !draggableEdit"
            style="max-height: 100vh; overflow: auto"
          >
            <v-draggable-fields
              :draggables="draggables"
              :formModel="formModel"
              v-model="model"
            ></v-draggable-fields>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// import the component and the necessary extensions
/* eslint no-useless-escape: off */
// import Vue from "vue";
// import VueAxios from "vue-axios";
import axios from "axios";
// Vue.use(VueAxios, axios);
import CKEditor from "ckeditor4-vue";

import * as fun from "../plugins/common";
// Vue.use(CKEditor);
// Vuetify Object (as described in the Vuetify 2 documentation)
// const vuetify = new Vuetify();

export default {
  // specify TiptapVuetify component in "components"
  components: {
    ckeditor: CKEditor.component,

    VMenuButton: () => import("../components/MenuButton.vue"),
    VDraggableFields: () => import("../components/Draggable.vue"),
  },
  props: {
    vModel: [Object, Array, String],
    objectName: String,
    label: String,
    formModel: [Object, Array],
    noFieldList: Boolean,
  },
  data: () => ({
    openItems: [],
    search: "",
    caseSensitive: false,
    isDraggable: false,
    draggableEdit: false,
    draggables: [],
    modelReady: false,
    model: null,
    isSms: false,
    type: "",
    formulaItems: [
      { itemText: "blank", itemValue: "blank" },
      { itemText: "formatNumber", itemValue: "formatNumber" },
      { itemText: "capitalize", itemValue: "capitalize" },
    ],
    totals: [
      {
        itemText: "transportation",
        itemValue: "totalByType('transportation')",
      },
      { itemText: "material", itemValue: "totalByType('material')" },
      { itemText: "labor", itemValue: "totalByType('labor')" },
      { itemText: "accessorials", itemValue: "totalByType('accessorials')" },
    ],
    inputItems: [
      {
        itemText: "Text Box",
        itemValue: "<input type='text' style='border:solid 1px'/>",
      },
      {
        itemText: "Check Box",
        itemValue: "<input type='checkbox'/>",
      },
      {
        itemText: "Text Area",
        itemValue: "<textarea></textarea>",
      },
      {
        itemText: "Radio Button",
        itemValue: "<input type='radio' name='r'/>",
      },
    ],
    specials: [
      {
        text: "company_logo",
        key: "company_logo",

        special: true,
      },
      {
        text: "Inputs",
        key: "inputs",

        special: false,
      },
      {
        text: "today",
        key: "today",

        special: true,
      },
      {
        text: "formula",
        key: "formula",

        special: true,
      },
      {
        text: "totals",
        key: "totals",

        special: true,
      },
      {
        text: "signature_pad",
        key: "sign",
        img: "sign-here.png",
        special: true,
      },
      {
        text: "initial_pad",
        key: "init",
        img: "initial-here.png",
        special: true,
      },
      {
        text: "sales_person_sign",
        key: "spsign",

        special: true,
      },
      {
        text: "customer_portal",
        key: "c_portal",

        special: true,
      },
      {
        text: "credit_card_link",
        key: "c_credit_card",
        link: true,

        special: true,
      },
      {
        text: "empty_space",
        key: "empty",
        link: false,

        special: true,
      },
    ],
    path: [],
    imgPath: "",

    editorConfig: {
      allowedContent: true,

      height: "350px",
      uploadUrl: "/upload_file",
      filebrowserUploadUrl: "/upload",
      filebrowserUploadMethod: "form",
      // removePlugins: "image,cloudservices",
      embed_provider:
        "//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}",
      extraPlugins:
        "justify,colorbutton,font,selectall,link,tableresize,embed,balloontoolbar,uploadimage,image2,forms,groupBy",
    },

    tree: [],
    treeItems: [],
    openAll: false,
    treeKey: 0,
    data: {
      // object_name: "emover_customers",
      category: "shipment",
    },
    dataItems: [],
    properties: null,
    iconHeight: "128px",
    categoryLabels: [
      { objectName: "v_shipment_letter_fields", label: "shipment" },
    ],
    errorMessage: "",
    successMessage: "",
    groupByFields: {
      "service.estimate_charges": "charge_category",
    },
    editor: CKEditor,
    myEditor: null,
    isFullScreen: false,
    // starting editor's content
  }),
  // created() {
  //   this.editor.on("instanceReady", (event) => {
  //     const editorInstance = event.editor;

  //     editorInstance.on("contentDom", () => {
  //       editorInstance.document.on("drop", (dropEvent) => {
  //         dropEvent.data.preventDefault();

  //         const range = editorInstance.getSelection().getRanges()[0];
  //         const droppedData = JSON.parse(
  //           dropEvent.data.$.dataTransfer.getData("text/plain")
  //         );

  //         const element = editorInstance.document.createElement("span");
  //         element.setText(droppedData.name);
  //         element.setStyle("position", "absolute");
  //         element.setAttribute("contenteditable", "false"); // Make sure it's not editable

  //         // Set the position where it was dropped
  //         const clientRect = editorInstance.window
  //           .getFrame()
  //           .$.getBoundingClientRect();
  //         const x = dropEvent.data.$.clientX - clientRect.left;
  //         const y = dropEvent.data.$.clientY - clientRect.top;

  //         element.setStyle("left", x + "px");
  //         element.setStyle("top", y + "px");

  //         range.insertNode(element);
  //         range.select();
  //       });
  //     });
  //   });
  //   this.editor.plugins.add("isDraggable", {
  //     init: function(editor) {
  //       editor.on("contentDom", function() {
  //         const editable = editor.editable();

  //         editable.attachListener(editable, "dragstart", function(evt) {
  //           // Handle internal drag start...
  //         });

  //         editable.attachListener(editable, "dragover", function(evt) {
  //           evt.data.preventDefault(); // Necessary to allow dropping
  //         });

  //         editable.attachListener(editable, "drop", function(evt) {
  //           // Handle internal drops...
  //           evt.data.preventDefault();
  //         });
  //       });
  //     },
  //   });
  // },
  activated() {
    console.log("activated");
  },
  mounted() {
    var that = this;
    window.CKEDITOR_NO_SECURITY_ALERT = true;
    this.errorMessage = "";
    // this.$root.$on("mainTabChanged", (t) => {
    //   console.log(t);
    //   if (t.data_object.objectName == "v_document") {
    //     t.tab = 1;
    //   }
    // });
    this.isDraggable = this.formModel.draggable;
    var portal = "portal_" + this.$root.portal_id;

    this.imgPath =
      window.location.host.indexOf("localhost") != -1
        ? "http://localhost:8080"
        : "https://" + portal + ".moverai.com";

    this.imgPath +=
      "/user_images/portal_" + this.$root.portal_id + "/templates/";

    this.model = fun.removeHtmlComments(this.vModel);
    if (this.formModel.draggable && this.formModel.draggables) {
      this.draggables = this.formModel.draggables;
    }
    this.category = this.formModel.category;
    this.type = this.formModel.type;
    this.isSms = this.formModel.sms;
    if (!this.formModel.sending_rules) {
      this.formModel.sending_rules = {};
    }
    // this.editorConfig.toolbar=this.isSms?
    if (this.data) {
      this.data.object_name =
        this.formModel.category == "shipment"
          ? "v_shipment_letter_fields"
          : this.formModel.category;

      if (this.type == "letter") {
        this.data.additional_structure = [{ obj_name: "v_company" }];
        this.data.additional_data = [{ obj_name: "charge_list" }];
      }
      if (this.type == "document") {
        this.data.additional_structure = [{ obj_name: "invoice" }];
      }
    }

    this.refresh();
    if (this.editorConfig) {
      var uploadUrl =
        this.serverURL +
        "/upload_file?server_url=" +
        fun.siteLocation() +
        "&portalid=" +
        this.$root.portal_id +
        "&object_name=templates";
      this.editorConfig.uploadUrl = uploadUrl;
      this.editorConfig.filebrowserUploadUrl = this.serverURL + "/browse";
      this.editorConfig.filebrowserParams = {
        csrf_token: this.csrfToken, // pass the CSRF token as a parameter
      };
      this.editorConfig.on = {
        // fileUploadResponse: function(evt) {
        //   const editor = evt.editor;
        //   that.onFileUploadResponse(editor);
        // },
        fileUploadResponse: function(evt) {
          try {
            var response = JSON.parse(evt.data.fileLoader.xhr.responseText);
            // Modify the response here if needed
            var url = that.convertPathToUrl(response.path);
            evt.data.url = url; // Make sure this points to the correct URL
            evt.stop(); // Prevent the default response handler
          } catch (e) {
            console.error("Failed to parse JSON response", e);
          }
        },
      };
    }

    if (this.dObject) {
      this.getData(this.dObject);
    }
    this.$root.getObjectStructure(
      "translate/letter_fields.json",
      this.model,
      (r) => {
        that.model = r;
      }
    );
    this.$root.$on("fileUploaded", (f) => {
      if (f.response.object_name == "templates") {
        that.formModel.imgUrl = this.imgPath += f.file.name
          .replaceAll(" ", "_")
          .replace(".pdf", ".jpg");
      }
      console.log(that.formModel.imgUrl);
    });
  },
  methods: {
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen;
    },
    convertPathToUrl(path) {
      var pathArray = path
        .replaceAll("\\", "/")
        .replaceAll("//", "/")
        .split("/");
      console.log(pathArray);
      // if(fun.isDev){
      //   pathArray.splice(0,2)
      // }else{
      //   pathArray.splice(0,3)
      // }
      var spliceIndex = pathArray.indexOf("user_images");
      pathArray.splice(0, spliceIndex);
      return pathArray.join("/");
    },
    onNamespaceLoaded(CKEDITOR) {
      var that = this;
      // this.myEditor = CKEDITOR;
      CKEDITOR.on("instanceReady", function(evt) {
        that.myEditor = evt.editor;
        // Step 2: Use CKEditor's API
      });
      // CKEDITOR.plugins.addExternal(
      //   "simplebox",
      //   "https://ckeditor.com/docs/ckeditor4/4.20.2/examples/assets/plugins/simplebox/",
      //   "plugin.js"
      // );

      // CKEDITOR.replace("editor", {
      //   // Add the Simple Box plugin.
      //   extraPlugins: "simplebox",

      //   // Besides editor's main stylesheet load also simplebox styles.
      //   // In the usual case they can be added to the main stylesheet.
      //   contentsCss: [
      //     "http://cdn.ckeditor.com/4.20.2/full-all/contents.css",
      //     "https://ckeditor.com/docs/ckeditor4/4.20.2/examples/assets/plugins/simplebox/styles/contents.css",
      //   ],

      //   // Set height to make more content visible.
      //   height: 500,
      //   removeButtons: "PasteFromWord",
      // });

      // var b = "add";
      // var a = {
      //   exec: function(editor) {
      //     var theSelectedText = editor.getSelection().getNative();
      //     alert(theSelectedText);
      //   },
      // };
      // CKEDITOR.plugins.add("abbr", {
      //   icons: "f004",
      //   init: function(editor) {
      //     editor.addCommand(b, a);
      //     editor.ui.addButton("addTags", {
      //       label: "Add Tag",
      //       // icon: this.path+"addTag.gif",
      //       command: b,
      //     });
      //   },
      // });
      // CKEDITOR.editor.ui.addButton("Abbr", {
      //   label: "Insert Abbreviation",
      //   command: "abbr",
      //   // toolbar: "insert",
      // });
      // CKEDITOR.editor.addCommand(
      //   "abbr",
      //   new CKEDITOR.dialogCommand("abbrDialog")
      // );
      CKEDITOR.plugins.add("groupBy", {
        requires: "table,contextmenu",
        init: function(editor) {
          var clickedCell, clickedTable;

          editor.addCommand("groupByCommand", {
            exec: function(editor) {
              if (!clickedCell || !clickedTable) return;

              // Logic to determine the column index
              var cellIndex = clickedCell.$.cellIndex;
              var columnName = clickedTable.$.rows[1].cells[
                cellIndex
              ].textContent.trim();

              clickedTable.setAttribute("data-group-by", columnName);
              that.addGroupByToTable(clickedTable, cellIndex);
            },
          });

          if (editor.contextMenu) {
            editor.addMenuGroup("tableGroup");
            editor.addMenuItem("groupByItem", {
              label: "Group By This Column",
              command: "groupByCommand",
              group: "tableGroup",
            });

            editor.contextMenu.addListener(function(element) {
              // Reset clickedCell and clickedTable on each context menu opening
              clickedCell = null;
              clickedTable = null;

              var ascendantCell =
                element.getAscendant("td", true) ||
                element.getAscendant("th", true);
              if (ascendantCell) {
                clickedCell = ascendantCell; // Store the clicked cell
                clickedTable = ascendantCell.getAscendant("table", true); // Store the clicked table
                return { groupByItem: CKEDITOR.TRISTATE_OFF };
              }
            });
          }
        },
      });
    },
    onFileUploadResponse(editor) {
      var that = this;
      this.$nextTick(() => {
        that.model = editor.getData();
      });
    },
    onInput(e) {
      this.model = e.target.innerText;
    },

    refresh() {
      var that = this;
      if (this.data) {
        axios
          .post(this.serverURL + "/get_data", this.data, {
            withCredentials: true,
          })
          .then((response) => {
            console.log(response.data);
            if (that.type == "letter") {
              that.dataItems = {
                properties: {
                  ...response.data.schema.properties,
                  ...{
                    company: {
                      properties:
                        response.data.additional_structure.v_company.properties,
                    },
                  },
                  ...{
                    charge_list: response.data.additional_model.charge_list,
                  },
                },
              };
            } else if (that.type == "document") {
              var invoiceProperties =
                response.data.additional_structure.invoice.properties;
              var fieldsExcluded = ["invoice_body", "document_name"];
              fieldsExcluded.forEach((e) => {
                delete invoiceProperties[e];
              });
              that.dataItems = {
                properties: {
                  ...response.data.schema.properties,
                  ...{
                    invoice: {
                      properties: invoiceProperties,
                    },
                  },
                },
              };
            } else {
              that.dataItems = {};
              that.dataItems.properties = response.data.schema.properties;
            }

            that.populateTree(response.data);
          });
      }
    },
    cleanupNestedTags() {
      var content = this.model;
      // content = content.replace(/{{([^{}]+)}}/g, (match, innerContent) => {
      //   return "{{" + innerContent.replace(/{{|}}/g, "") + "}}";
      // });
      // Repeatedly search for nested tags and remove the inner set of braces
      // let previousContent = "";
      // while (content !== previousContent) {
      //   previousContent = content;
      //   content = content.replace(/{{\s*{{/g, "{{");
      //   content = content.replace(/}}\s*}}/g, "}}");
      // }
      // let replaced;

      // do {
      //   replaced = false;
      //   content = content.replace(
      //     /{{([^{}]*?){{(.*?)}}([^{}]*?)}}/g,
      //     (match, prefix, innerContent, suffix) => {
      //       replaced = true;
      //       return `{{${prefix}${innerContent}${suffix}}}`;
      //     }
      //   );
      // } while (replaced);
      let cleanedContent = content;
      let previous;
      try {
        do {
          previous = cleanedContent;
          cleanedContent = cleanedContent
            .replace(/{{([^{}]*){{/g, "{{ $1")
            .replace(/}}([^{}]*)}}/g, "$1 }}");
        } while (cleanedContent !== previous);
        const htmlEntities = {
          "&nbsp;": " ",
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'",
        };

        for (let entity in htmlEntities) {
          const regex = new RegExp(entity, "g");
          cleanedContent = cleanedContent.replace(regex, htmlEntities[entity]);
        }
      } catch (error) {
        //
      }
      this.model = cleanedContent;

      // editorInstance.setData(content);
    },
    getParentPath(text) {
      var getPath = function(items) {
        var path = "";
        items.forEach((t) => {
          if (path) {
            return path;
          }
          if (t.children) {
            path = getPath(t.children);
          } else {
            if (t.text == text) {
              path = t.parentPath;
            }
          }
        });
        return path;
      };

      var parentPath = getPath(this.treeItems);
      return parentPath;
    },
    getItem(properties, items, parentPath, parent, parents) {
      // items.sort((a, b) => a.text.localeCompare(b.text));
      if (!parentPath) {
        var categoryLabels = this.categoryLabels.filter((a) => {
          return a.objectName == this.data.object_name;
        })[0];
        var categoryLabel = categoryLabels
          ? categoryLabels.label
          : this.data.object_name;
        // items.push({
        //   text: this.data.object_name,
        //   topItem: true,
        // });
      }

      //this.data.object_name
      if (properties) {
        Object.keys(properties).forEach((k) => {
          // var treeItem = that.getItem(k, data);
          // if (!parents && !parent) {
          //   parents = [];
          // }
          // if (parent) {
          //   if (!parents.includes(parent)) {
          //     parents.push(parent);
          //   }
          // }
          if (k == "service") {
            console.log(k);
          }
          if (k == "estimate_charges") {
            console.log(k);
          }
          if (k == "resources") {
            console.log(k);
          }
          if (!properties[k].hiddenInLetter) {
            var treeItem = {
              text: k,
              parentPath: parentPath,
              parent: parent,
              parents: parents,
            };
            items.push(treeItem);
            if (k == "itinerary") {
              console.log(k);
            }
            if (
              properties[k].properties &&
              (!properties[k].table_properties ||
                properties[k].ignore_display_in_letter)
            ) {
              treeItem.children = [];
              var p = "";
              if (parentPath) {
                // p = parentPath + "['" + k + "']";
                p = parentPath + "." + k;
              } else {
                p = k;
              }

              this.getItem(
                properties[k].properties,
                treeItem.children,
                p,
                k,
                parents
              );
              // console.log(k.properties);
            }
          }
          // that.treeItems.push(treeItem);
        });
      }

      // return treeItem;
    },
    populateTree(data) {
      this.tree = [];
      this.treeItems = [];
      var chargeNames = {};
      if (data.additional_model) {
        if (data.additional_model.charge_list) {
          fun.sortObjects(data.additional_model.charge_list, "charge_name");
          data.additional_model.charge_list.forEach((c) => {
            chargeNames[c.charge_name] = {
              parentPath: "charge_list",
            };
          });
        }
        this.properties = {
          ...data.schema.properties,
          ...{
            company: {
              properties: data.additional_structure.v_company.properties,
            },
          },
          ...{
            charge_list: {
              properties: chargeNames,
            },
          },
        };
      } else {
        this.properties = data.schema.properties;
      }

      this.properties = fun.sortPropertiesInObject(this.properties);
      var that = this;

      that.getItem(this.properties, that.treeItems);
      that.modelReady = true;
      // this.treeItems.concat(specials);
      // this.treeKey = !this.treeKey;
    },

    addGroupByToTable1(clickedTable, columnIndex) {
      var table = clickedTable.$;
      var groupByField = table.getAttribute("data-group-by");
      var tblName = table.getAttribute("summary");

      // Assuming match is successful, simplified for clarity
      const regex = /{{m\.(\w+)}}/;
      const match = groupByField.match(regex);
      if (match) {
        groupByField = match[1]; // Directly using the property name matched
      }

      Array.from(table.rows).forEach((row, index) => {
        var cellToMove = row.removeChild(row.cells[columnIndex]);
        row.insertBefore(cellToMove, row.cells[0]);
        if (index === 1) {
          // Specifically targeting the second row
          // Creating a div container for complex HTML structure
          let div = document.createElement("div");
          div.innerHTML = `<td><div v-if="!newValueInGroupBy('${tblName}', '${groupByField}', i)">
                <hr /><h3 class="pa-2">{{m.${groupByField}}}</h3></div></td>`;

          // Preparing the new cell content
          let newCellContent = div.firstChild;

          // Move the targeted cell to the first position

          // Replace the inner content of the moved cell
          cellToMove.innerHTML = newCellContent.innerHTML; // Insert complex HTML structure
          cellToMove.classList.add("group-by-cell");

          // Attempting to replace the v-for directive in row's HTML representation
          let newRowHTML = row.outerHTML.replace(
            `model.${tblName}`,
            `sorted(${tblName}, '${groupByField}')`
          );

          // Replace the current row's outerHTML with the modified HTML
          let newRow = document.createElement("tr"); // Temporarily holds the new row content
          newRow.innerHTML = newRowHTML; // Set innerHTML since outerHTML is read-only for new elements
          row.parentNode.replaceChild(newRow, row); // Replace old row with new content in the DOM
        }
      });
    },

    addGroupByToTable(clickedTable, columnIndex) {
      var table = clickedTable.$;
      var groupByField = table.getAttribute("data-group-by");
      var tblName = table.getAttribute("summary");

      const regex = /{{m\.(\w+)}}/;
      const match = groupByField.match(regex);

      const placeholder = match[0]; // Full match "{{m.item}}"
      const propertyName = match[1]; // Property name "item"
      groupByField = groupByField.replace(placeholder, propertyName);

      Array.from(table.rows).forEach((row, i) => {
        var cellToMove = row.removeChild(row.cells[columnIndex]);
        row.insertBefore(cellToMove, row.cells[0]);
        if (i == 1) {
          var groupByHTML =
            `<div v-if="!newValueInGroupBy('` +
            tblName +
            `', '` +
            groupByField +
            `', i) ></div>`;

          cellToMove.classList.add("group-by-cell");
          let newCellHTML = `<div v-if="!newValueInGroupBy('${tblName}', '${groupByField}', i)"><hr /><h3 class="pa-2">${placeholder}</h3></div>`;
          cellToMove.innerHTML = newCellHTML;
          let newRowHTML = row.outerHTML.replace(
            `model.${tblName}`,
            `sorted('${tblName}', '${groupByField}')`
          );

          // Replace the current row's outerHTML with the modified HTML

          // Creating a temporary container to facilitate the replacement
          let tempContainer = document.createElement("tbody");
          tempContainer.innerHTML = newRowHTML; // Using innerHTML of a temporary container

          // Replace the current row with the modified HTML
          row.parentNode.replaceChild(tempContainer.firstChild, row);
        }
      });
    },

    makeTable(obj, text, parent, topTbl) {
      const tb = "m";
      var attr = "";
      if (!parent) {
        attr = "model.";
      }
      var addChildTitle = false;
      var columnProperty = "";
      var mainColumn = "";
      var wrapper = "";
      if (obj["v-bind"] && obj["v-bind"].lettersColumnsProperty) {
        columnProperty = obj["v-bind"].lettersColumnsProperty;
        mainColumn = obj["v-bind"].mainColumn;
        wrapper = document.createElement("table");
        var wrapTr = document.createElement("tr");
        var wrapTd = document.createElement("td");
        var wrapTrh = document.createElement("tr");
        var wrapTh = document.createElement("th");
        wrapper.appendChild(wrapTrh);
        wrapTrh.appendChild(wrapTh);
        wrapTh.setAttribute(
          "v-for",
          "(group, key) in _.groupBy(" +
            attr +
            text +
            ", '" +
            columnProperty +
            "')"
        );
        // wrapTh.innerText = "{{key}}";
        wrapTh.setAttribute("key", "key");
        wrapper.appendChild(wrapTr);
        wrapper.setAttribute("cellspacing", "10");
        wrapper.setAttribute("style", "width:100%");
        wrapTr.appendChild(wrapTd);
        wrapTd.setAttribute(
          "v-for",
          "(group, key) in _.groupBy(" +
            attr +
            text +
            ", '" +
            columnProperty +
            "')"
        );
        wrapTd.setAttribute("key", "key");
        wrapTd.setAttribute("valign", "top");
        wrapTd.setAttribute("cellspacing", "10");

        // console.log(obj["v-bind"].lettersColumnsProperty);
      }
      if (!topTbl) {
        topTbl = document.createElement("table");
        topTbl.setAttribute("border", "1");
        topTbl.setAttribute("summary", text);
        topTbl.setAttribute("style", "width:100%");
        // topTbl.setAttribute("columnProperty", columnProperty);
      } else {
        addChildTitle = true;
      }

      var cols = 0;

      var makeInnerTable = false;
      if (parent) {
        topTbl.setAttribute("v-for", tb + " in " + attr + text);
        topTbl.setAttribute("style", "width:100%");
      }

      var headTr = document.createElement("tr");
      var prop = obj.properties || obj.table_properties.schema.properties;
      Object.keys(prop).forEach((k) => {
        if (!prop[k]["hiddenInLetter"] && k != columnProperty) {
          if (prop[k].newLineInTable) {
            makeInnerTable = true;
          } else {
            var th = document.createElement("th");
            var title = prop[k].title;
            if (mainColumn && k == mainColumn) {
              title = "{{ capitalize(key) }}";
            }
            th.appendChild(document.createTextNode(title || fun.capitalize(k)));
            headTr.appendChild(th);
            cols += 1;
          }
        }
      });

      var mainDataRow = document.createElement("tr");
      if (!parent) {
        var forAttr = attr + text;
        if (wrapper) {
          forAttr += `.filter(f => {return f.${columnProperty} == key})`;
        }
        mainDataRow.setAttribute("v-for", `(${tb}, i) in ${forAttr}`);
        mainDataRow.setAttribute("key", "i");
      }
      if (addChildTitle) {
        var childTitleRow = document.createElement("tr");
        var childTitle = childTitleRow.appendChild(
          document.createElement("th")
        );
        childTitle.appendChild(
          document.createTextNode(fun.capitalize(text.split(".")[1]))
        );
        topTbl.appendChild(childTitleRow);
      }
      topTbl.appendChild(headTr);
      topTbl.appendChild(mainDataRow);
      var td;
      Object.keys(prop).forEach((k) => {
        if (!prop[k]["hiddenInLetter"] && k != columnProperty) {
          if (k == "address") {
            k = "address.address";
          }
          var obj = this.isTable(k);
          if (obj) {
            var t = this.makeTable(
              obj,
              tb + "." + k,
              true,
              makeInnerTable ? topTbl : ""
            );
            if (!makeInnerTable) {
              td = mainDataRow.appendChild(document.createElement("td"));
              td.appendChild(t);
            }
          } else if (!prop[k].newLineInTable) {
            td = mainDataRow.appendChild(document.createElement("td"));
            td.appendChild(document.createTextNode("{{" + tb + "." + k + "}}"));
          }
        }
      });
      if (wrapper && wrapTd) {
        wrapTd.appendChild(topTbl);
        return wrapper;
      }
      return topTbl;
    },

    isTable(itemName) {
      if (itemName == this.data.object_name) {
        return {
          title: itemName,
          properties: this.dataItems.properties,
        };
      }
      var obj = fun.getObjectByKey(this.dataItems, itemName);
      if (obj && obj["x-display"] && !obj.ignore_display_in_letter) {
        var tblObjects = ["d-table", "v-charge", "v-collapsible", "d-iterator"];

        if (tblObjects.includes(obj["x-display"])) {
          return obj;
        }
      }
    },
    fixImages(htmlString) {
      var tempDiv = document.createElement("div");

      // Set its inner HTML to your string
      tempDiv.innerHTML = htmlString;

      // Get all img elements
      var imgs = tempDiv.getElementsByTagName("img");

      // Iterate over each img element
      for (var i = 0; i < imgs.length; i++) {
        // If the image does not have an alt attribute, or if it's empty
        if (
          !imgs[i].hasAttribute("alt") ||
          imgs[i].getAttribute("alt").trim() === ""
        ) {
          // Add a default alt attribute
          imgs[i].setAttribute("alt", "default alt text");
        }
      }

      // Get the manipulated HTML string

      return tempDiv.innerHTML;
    },
    formatPath(path) {
      var myPath = path.split(".");
      var formattedPath = [];
      myPath.forEach((p) => {
        if (p.includes("-")) {
          formattedPath.push("['" + p + "']");
        } else {
          formattedPath.push(p);
        }
      });
      formattedPath = formattedPath.join(".");
      formattedPath = formattedPath.replace(".[", "[");
      return formattedPath;
    },
    insertAtCursor(item, draggable) {
      var special = item.special || item.item;

      var itemName = item.text;
      var obj = this.isTable(itemName);

      if (item.text == "address") {
        item.text = "address.address";
      }
      // var text = item.parentPath
      //   ? item.parentPath + "['" + item.text + "']"
      //   : item.text;
      var text = "";
      if (item.parentPath) {
        item.parentPath = this.formatPath(item.parentPath);
        if (item.parent && this.isTable(item.parent)) {
          text = item.parentPath + "[0]['" + item.text + "']";
          item.text = text;
        } else {
          // if (
          //   this.path.length &&
          //   this.path[this.path.length - 1] == item.parent
          // ) {
          if (item.children && item.children.length) {
            // this.path.push(item.text);
            return;
            // } else {
            //   text = "{{model." + this.path.join(".") + "." + text + "}}";
          }
          // }
          // item.parentPath + "['" + item.text + "']";
          // text = item.parentPath;
          // item.text = text;
        }
      } else if (!obj) {
        if (!item.children || item.children.length == 0) {
          text = item.text;
        } else {
          // this.path.push(item.text);

          return;
        }
      }

      var isText = true;
      var tbl = "";

      if (obj) {
        if (item.parent && this.isTable(item.parent)) {
          console.log(item.parent);
          tbl = document.createElement("div");
          tbl.setAttribute("v-for", "(p,i) in model." + item.parentPath);
          tbl.setAttribute(":key", "p._id");

          tbl.appendChild(this.makeTable(obj, item.text, true));
        } else {
          text = item.text;
          if (item.parent) {
            text = item.parent + "." + item.text;
          }
          tbl = this.makeTable(obj, text);
        }

        isText = false;
      } else {
        if (!special) {
          if (item.parentPath == "charge_list") {
            text = "{{Number(chargeByName('" + item.text + "'))}}";
          } else {
            if (item.parentPath && !this.isTable(item.parent)) {
              text = "{{model." + item.parentPath + "." + item.text + "}}";
            } else {
              text = "{{model." + item.text + "}}";
            }
          }
        } else {
          item.special = true;
          var value = item.text || item.item.value;
          switch (value) {
            case "blank":
              isText = true;
              text = "{{  }}";
              break;
            case "customer_portal":
              isText = true;
              text = "customer_portal_link";
              break;
            // case "totals":
            //   isText = true;
            //   text = value;
            //   break;

            case "sales_person_sign":
              isText = true;
              text = "sales_person_sign";
              break;
            case "company_logo":
              isText = true;
              text = "company_logo";
              break;
            default:
              if (!value.startsWith("<")) {
                if (value.startsWith("totalByType")) {
                  text = "{{ " + value + " }}";
                } else {
                  text = "{{ " + value + "() }}";
                }
              } else {
                text = value;
              }

              break;
          }
        }
      }

      // console.log(obj);
      var sel, range;

      if (window.getSelection) {
        if (!this.isSms) {
          if (!this.formModel.draggable) {
            var editor = document.getElementById("editor");
            var editorWindow = editor.getElementsByTagName("iframe")[0]
              .contentWindow;
            sel = editorWindow.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
              range = sel.getRangeAt(0);
              range.deleteContents();
            }
          }

          if (isText) {
            if (!item.special || (!item.img && !item.link)) {
              if (!this.formModel.draggable) {
                range.insertNode(document.createTextNode(text));
              } else {
                if (item.text != "empty_space") {
                  this.addToDraggable(text);
                } else {
                  this.addToDraggable(" ");
                }
              }
            } else if (item.link) {
              var link = document.createElement("a");

              // link.setAttribute("text", "Please click here to pay");
              link.innerText = "Please click here to pay";

              link.setAttribute("href", "credit_card_link");
              if (!this.formModel.draggable) {
                range.insertNode(link);
              } else {
                this.addToDraggable(link.innerHTML);
              }
            } else {
              var el = document.createElement("a");

              var id = fun.guid();
              el.setAttribute("id", id);

              el.setAttribute("href", "#" + item.key + "_" + id);
              var img = document.createElement("img");
              img.setAttribute("src", item.img);
              img.setAttribute("style", "height:" + this.iconHeight);
              el.appendChild(img);
              // this.formModel.send_as_link = "1";
              if (item.innerHTML) {
                var span = document.createElement("span");
                span.innerHTML = item.innerHTML;
                el.appendChild(span);
              }

              // el.innerHTML = text;
              if (!this.formModel.draggable) {
                range.insertNode(el);
              } else {
                this.addToDraggable(el.outerHTML);
              }
            }
          } else {
            // var el = document.createElement("div");
            // el.innerHTML = text;
            if (!this.formModel.draggable) {
              range.insertNode(tbl);
            } else {
              this.addToDraggable(tbl.outerHTML);
            }
          }
          if (!this.formModel.draggable) {
            sel.empty();
          }
        }
      } else {
        if (!this.formModel.draggable) {
          sel = window.getSelection();
          range = sel.getRangeAt(0);
          range.insertNode(document.createTextNode(text));
        }
      }

      // } else if (document.selection && document.selection.createRange) {
      //   document.selection.createRange().innerHTML = text;
      //   document.selection.empty();
      // }
      if (this.isSms) {
        this.model = document.getElementById("editor").innerText;
      } else {
        if (!this.formModel.draggable) {
          this.model = editor.getElementsByTagName(
            "iframe"
          )[0].contentWindow.document.body.innerHTML;
        }
      }
      this.cleanupNestedTags();
      // } else {
      //   console.log(text);
      //   this.addToDraggable(text);
      // }
    },
    addToDraggable(text) {
      this.draggables.push({
        text: text,
        x: 10,
        y: document.getElementById("draggable_div").scrollTop,
        width: 150,
        height: 35,
      });
      this.formModel.draggables = this.draggables;
    },
    filterItem(item, queryText) {
      let match = item.text.toLowerCase().includes(queryText.toLowerCase());
      let childMatch = false;

      // If the item has children, check each child recursively
      if (item.children && item.children.length > 0) {
        childMatch = item.children.some((child) =>
          this.filterItem(child, queryText)
        );

        // If any child matches, ensure this item is in the openItems list
        if (childMatch && !this.openItems.includes(item.text)) {
          this.openItems.push(item.text);
        }
      }

      return match || childMatch;
    },
  },
  computed: {
    // filter() {
    //   return this.caseSensitive
    //     ? (item, search, textKey) => item[textKey].indexOf(search) > -1
    //     : undefined;
    // },
    filteredItems() {
      return this.search
        ? this.treeItems.filter((item) => this.filterItem(item, this.search))
        : this.treeItems;
    },
  },

  watch: {
    search(newVal) {
      this.openItems = [];

      if (!newVal) {
        this.openAll = false;
        this.treeKey = !this.treeKey;
      }
    },
    model() {
      this.$emit("input", this.model);
    },
    isDraggable() {
      this.formModel.draggable = this.isDraggable;
    },
    formModel: {
      handler: function(newValue, oldValue) {
        if (this.data && this.data.object_name != newValue.category) {
          this.data.object_name = newValue.category;
          // this.refresh();
        }
        this.isSms = newValue.sms;
        if (this.isSms) {
          document.getElementById("editor").innerText = this.model;
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
.full-screen-editor {
  position: fixed;
  padding: 20px;
  top: 50px;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  z-index: 10000000000 !important;
  background-color: white;
}

.cke_notifications_area {
  display: none !important;
}

.cke_button__validate_icon:before {
  /* https://github.com/google/material-design-icons/blob/master/iconfont/codepoints */
  content: "\e92f";
  font-family: "Material Icons";
  font-size: large;
}

.v-content-editable {
  height: 450px;
  overflow-y: auto;
  border: 1px solid;
  padding: 10px;
  color: black;
}

/* .ck-editor__editable {
  min-height: 500px;
} */
/* .ck-editor__editable {
  min-height: 600px !important;
}
.cke_contents {
  height: 600px !important;
}
iframe {
  min-height: 600px;
} */
</style>
